'use client';

import { Suspense } from 'react';
import RoleLoginContent from '@/components/auth/RoleLoginContent';

export default function AdminLoginPage() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-background flex items-center justify-center"><div className="text-muted-foreground text-sm">Loading...</div></div>}>
      <RoleLoginContent
        role="admin"
        roleLabel="Administrator"
        redirectPath="/enterprise-admin-platform"
        accentColor="blue"
        description="Enterprise Administration Portal — Admin credentials required"
        features={[
          { icon: '⬡', label: 'Operations Dashboard', desc: 'Bookings, settlements, and reconciliation' },
          { icon: '◈', label: 'Supplier Management', desc: 'Viator sync, Crystal Cruises, TourRadar' },
          { icon: '✦', label: 'Analytics & Reporting', desc: 'Executive reports and business intelligence' },
        ]}
      />
    </Suspense>
  );
}
